export const FIN_TYPE_INCOME = '12100' // 分类：收入

export const FIN_TYPE_PAY = '12101' // 分类：支出

export const BELONG_BAO = '17101' // 靖宝

export const SORT_INCOME = '10105' //类型：个人收入

export const SORT_EAT = '10100' //类型：餐饮

export const PAY_MODE_POCKET = '22100' //零用钱卡

export const BILL_TYPE_STORED_VALUE = '20102' //储值类型

export const BILL_TYPE_OVERDRAFT = '20101' //分期

export const BILL_TYPE_OVERDRAFT_STORE = '20103' //储值型分期

export const STATUS_CD_1000 = '1000' //生效

export const COMMON_TRUE = 1

export const COMMON_FALSE = 0

export const BAO_REC_TYPE_HOLIDAY = '23100'

export const BAO_REC_FLAG_START = '24100'

export const BAO_REC_FLAG_END = '24101'

export const BAO_REC_FLAG_REALTIME = '24102'

export const BAO_REC_FLAG_MIDDLE = '24103'